import styled from 'styled-components'

import { color } from '~/styles/variables'

export const Wrap = styled.div`
  display: block;
  margin: 10px 0;

  label{
    display: inline-flex;
    font-weight: 400;
    cursor: pointer;
    align-items: center;
    margin: 0;
    padding: 10px 0;
    position: relative;

    span{
      &:last-child{
        padding-left: 10px;
      }
    }

    .circle-check{
      width: 20px;
      height: 20px;
      border: 2px solid #707070;
      color: #707070;
      border-radius: 50%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      
      &:before{
        font-weight: 700;
        color: inherit;
        line-height: 1;
        font-size: 13px;
      }
    }

    input:checked + .circle-check {
      background: ${color.primary};
      border-color: ${color.primary};

      &:before{
        color: #FFFFFF;
      }
    }

    input{
      display: none;
    }

    &:hover{
     color: ${color.primary};

     .circle-check{
      border-color: ${color.primary};
      color: ${color.primary};
     }
    }
  }
`